<script setup lang="ts">
import { defineProps, PropType } from 'vue'

import TagPill from '@base/components/TagPill/TagPill.vue'
import { TagPill as TypeTagPill } from '@base/_types/TagPill'

const props = defineProps({
  modelValue: {
    type: Array as PropType<string[]>,
    required: true
  },
  tags: {
    type: Array as PropType<TypeTagPill[]>,
    required: true
  }
})

const emit = defineEmits(['update:modelValue'])

type TagState = {
  checked: boolean
  value: string
}

const emitUpdateModelValue = (pillState: TagState) => {
  // Copy existing list
  let newModelValue = [...props.modelValue]

  // console.log('current modelValue', newModelValue)
  // console.log('pillState', pillState)

  if (pillState.checked) {
    // Add to list if not already present
    if (!props.modelValue.includes(pillState.value)) {
      newModelValue.push(pillState.value)
    }
  } else {
    // Remove from list
    newModelValue = newModelValue.filter((x) => x !== pillState.value)
  }

  // console.log('new modelValue', newModelValue)

  emit('update:modelValue', newModelValue)
}
</script>

<template>
  <div data-test="tag-pill-stacked" class="tag-pill-stacked">
    <div class="tag-pill-stacked__tags">
      <template v-for="(tag, index) in tags" :key="index">
        <component
          :is="tag.canClick ? 'router-link' : 'div'"
          :to="
            tag.canClick
              ? {
                  path: 'community',
                  query: {
                    tags: tag.value
                  }
                }
              : undefined
          "
        >
          <TagPill
            class="tag-pill-stacked__tag"
            v-bind="tag"
            :model-value="modelValue.includes(tag.value)"
            @update:modelValue="
              emitUpdateModelValue({ checked: $event, value: tag.value })
            "
          />
        </component>
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
$rowGap: var(--spacing--8);

.tag-pill-stacked {
  &__tags {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }

  &__tag {
    margin: var(--spacing--8);
  }
}
</style>
